<template>
  <div class="mt-3">
    <b-img :src="bannerAd.photo" fluid-grow rounded  @click="clickBannerAd"></b-img>
  </div>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
  name: "BannerAd",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: '',
      busy: false,
      bannerAd: null,
      studentHash: this.$root.getToken(),
    }
  },
  props: {
    b: {  // bannerAd object
      type: Object
    },
  },
  computed: {
   },
  methods: {
    gotoUrl(url) {
      // window.location.href = url
      window.open(url, '_blank')
    },
    clickBannerAd(e) {
      if (this.busy) return
      if (this.debug) console.log(`bannerAd: ${this.bannerAd.hash}  studentHash: ${this.studentHash}`)
      this.busy = true
      service
        .clickBannerAd(this.bannerAd.hash, this.studentHash)
        .then(res => {
          if (this.debug) console.log(res);
        })
        .finally(() => {
          this.busy = false
          this.gotoUrl(this.bannerAd.url)
        })
        .catch(e => console.log(e))
    }
  },
  created() {
    // console.log(this.mb)
    this.bannerAd = this.b || { id:0 }
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {
    this.busy = false
    this.bannerAd = null
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BannerAd.vue